import { render, staticRenderFns } from "./Vereadores.vue?vue&type=template&id=6b3b41a9&scoped=true"
import script from "./Vereadores.vue?vue&type=script&lang=js"
export * from "./Vereadores.vue?vue&type=script&lang=js"
import style0 from "./Vereadores.vue?vue&type=style&index=0&id=6b3b41a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b41a9",
  null
  
)

export default component.exports